import { Routes, Route } from 'react-router-dom'
import ResetPassword from './pages/ResetPassword'
import ConfirmEmail from './pages/ConfirmEmail'
import AuthCallback from './pages/AuthCallback'
import AuthConfirm from './pages/AuthConfirm'
import Home from './pages/Home'
import EventSharePage from './pages/EventSharePage'
import GroupSharePage from './pages/GroupSharePage'
import CaptainPortal from './pages/captain/CaptainPortal'

function App() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/confirm-email" element={<ConfirmEmail />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route path="/auth/confirm" element={<AuthConfirm />} />
      <Route path="/share/event/:id" element={<EventSharePage />} />
      <Route path="/share/group/:id" element={<GroupSharePage />} />
      <Route path="/captain/:slug" element={<CaptainPortal />} />
    </Routes>
  )
}

export default App
